import { cssColorValue, cssSpacing, semanticColors } from "../../styles/index.mjs";
import { IconChevronDown } from "../Icon/icons/IconChevronDown/index.mjs";
import styled from "../../styled-components.mjs";
export var Arrow = styled(IconChevronDown).attrs({
  size: 'small',
  'aria-hidden': 'true'
}).withConfig({
  displayName: "Arrow",
  componentId: "sc-ijqpb-0"
})(["color:", ";padding-inline-start:", ";"], cssColorValue(semanticColors.textSubdued), cssSpacing('tighter-2', '8px'));